<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardImageLandScape :cardContent="content" @funcRoute="funcRoute" />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import '../../../assets/scss/_chineseStyle.scss';
import CardImageLandScape from './components/CardImageLandScape.vue';
import {mapGetters} from 'vuex';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardImageLandScape, LoadingMDL},
  name: 'CTA01',
  data() {
    return {
      content: {},
      lang: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      topicId: '',
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      v3Data: {},
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
    saveContentStatusv4: function (val) {
      //if this next path exist
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
  },

  mounted() {},

  created() {
    this.onLoad();
  },

  beforeDestroy() {
    // this.commitPayloadData();
  },
  methods: {
    onLoad() {
      this.loading = true;
      this.lang = this.$store.state.language.language;
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `CTA01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    funcRoute(val) {
      this.commitPayloadData(val);
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          //onNext
          const nextPath = `/v4/${path[0]}/${path[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
  },
};
</script>
<style></style>
